module.exports = __webpack_public_path__ + "static/media/dish12.420f0916.jpg";